import { isArray } from '@dimjs/lang';
import { classNames } from '@dimjs/utils';
import { toArray } from '@flatbiz/utils';
import { cloneElement, CSSProperties, Fragment } from 'react';
import { CommonPropsWithChildren } from '../utils/native-props';
import { px2rem } from '../utils/pxrem';
import './style.less';

export type FlexLayoutProps = {
  fullIndex?: number | number[];
  direction?: 'vertical' | 'horizontal';
  height?: number | string;
  onClick?: () => void;
  gap?: number;
} & CommonPropsWithChildren;

/**
 * flex布局
 * @param props
 * @returns
 */
export const FlexLayout = (props: FlexLayoutProps) => {
  const childrens = (isArray(props.children) ? props.children : [props.children]) as JSX.Element[];
  const direction = props.direction || 'vertical';
  const gap = props.gap ? px2rem(props.gap) : 0;

  const style = {} as CSSProperties;
  if (props.height) {
    style.height = typeof props.height === 'number' ? px2rem(props.height) : props.height;
  }

  const fullIndexList = toArray<number>(props.fullIndex);
  return (
    <div
      className={classNames('v-flex-layout', `v-flex-${direction}`, props.className)}
      style={{ ...style, ...props.style }}
      onClick={props.onClick}
    >
      {childrens.map((children, index) => {
        if (!children?.props) return;
        const childrenStyle = children.props.style || {};
        const style = fullIndexList.includes(index) ? { flex: 1, ...childrenStyle } : childrenStyle;
        if (index < childrens.length - 1 && !!gap) {
          if (direction === 'horizontal') {
            style.marginRight = gap;
          } else {
            style.marginBottom = gap;
          }
        }
        return <Fragment key={index}>{cloneElement(children, { style })}</Fragment>;
      })}
    </div>
  );
};
